import './Logo.css';

function Logo() {
    return (
        <div className="logo">
            <img
                src="/assets/images/APC-Plus.png"
                alt="APC Plus"
                className="logo__image"
            />
        </div>
    );
}

export default Logo;
